module.exports = fox._r("images/empty-icon-photoset.png", __webpack_public_path__ + "_/_/_/common/frame/images/empty-icon-photoset.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/empty-icon-photoset.png
// module id = 90
// module chunks = 2